import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPersonas } from "services/clientPersona";

export const GET_PERSONAS = createAsyncThunk(
  "@@PERSONAS/GET_PERSONAS",
  async (...args) => {
    const state = args[1].getState();
    if (state.personas.length === 0) {
      const response = await getPersonas();
      if (response?.data) return [...response?.data];
    }
    return state.personas;
  }
);

const personas = createSlice({
  name: "@@PERSONAS",
  initialState: [],
  reducers: {},
  extraReducers: {
    [GET_PERSONAS.fulfilled]: (state, action) => {
      return action.payload;
    },
  },
});

export default personas.reducer;
